import React, { useState } from 'react';
import { RootState } from '../../../redux/store';
import { useDispatch, useSelector } from 'react-redux';
import { postDataPage, setPageNo, setPageSize } from '../../../redux/newsSlice';
import { Tnews } from '../../../type/news';
import { MINIO } from '../../../data/data';
import { Link } from 'react-router-dom';
import { factory } from 'typescript';
import { FiCalendar } from 'react-icons/fi';

interface ScrollItemNewsProps {
	keyword: string;
	fix?: boolean;
}

const ScrollItemNews = (props: ScrollItemNewsProps) => {
	const { keyword, fix = factory } = props;
	const [loading, setLoading] = useState(false);
	const [hasMore, setHasMore] = useState(true);
	const { newsPage, totalRows, pageNo, pageSize } = useSelector(
		(state: RootState) => state.reducer.news
	);

	const dispatch = useDispatch<any>();

	const getNewsList = async (page: number, pageSize: number) => {
		const params = {
			pageNo: 0,
			pageSize: 10,
			sortType: 'DESC',
			filter: [
				{
					key: 'name',
					value: keyword,
					operation: 'MATCH',
					conjunction: 'or',
				},
				{
					key: 'content',
					value: keyword,
					operation: 'MATCH',
					conjunction: 'or',
				},
				{
					key: 'content_plain',
					value: keyword,
					operation: 'MATCH',
					conjunction: 'or',
				},
				{
					key: 'active',
					value: true,
					operation: 'EQUAL',
					conjunction: 'and',
				},
			],
		};
		dispatch(postDataPage(params));
		dispatch(setPageNo(page));
		dispatch(setPageSize(pageSize));
	};

	const handleScroll = async (e: React.UIEvent<HTMLDivElement>) => {
		const { scrollTop, clientHeight, scrollHeight } = e.currentTarget;

		if (
			scrollHeight - scrollTop === clientHeight &&
			!loading &&
			!(totalRows === newsPage.length)
		) {
			setLoading(true);
			getNewsList(pageNo + 1, 10);
			setLoading(false);
		}
	};

	return (
		<>
			<div
				onScroll={handleScroll}
				className={` ${
					!fix ? 'max-h-[calc(100vh-150px)] overflow-auto' : 'mb-[100px]'
				} `}
			>
				{newsPage.map((item: Tnews, index: number) => {
					const text = item.content_plain || '';
					const plain = text.substring(0, 200);
					return (
						<div
							key={index}
							className="flex mb-4"
						>
							<div className="bg-gray-50 text-center overflow-hidden max-w-[100px] rounded-sm">
								<Link to={`/admin/news/${item.slug}`}>
									<img
										src={`${MINIO}/${item.thumbnail}`}
										className=""
										alt={item.name}
									/>
								</Link>
							</div>
							<div className="ml-3">
								<Link to={`/admin/news/${item.slug}`}>
									<h2 className="text-[13px] font-medium block">{item.name}</h2>
								</Link>
								<span className="text-[10px] text-gray-400 m-0 p-0 flex items-center">
									<FiCalendar className="mr-2" />
									{new Date(item.createDate).toLocaleDateString()} -{' '}
									{new Date(item.createDate).toLocaleTimeString()}
								</span>
								<p className="text-[11px] text-justify">{plain}...</p>
							</div>
						</div>
					);
				})}
			</div>
		</>
	);
};

export default ScrollItemNews;
